// 注册一些自定义工具组件等
import tips from "./zh-ch"; //提示语

export default {
  install: (Vue, options) => {
    // Execl兼容IE10
    (function() {
      Object.setPrototypeOf =
        Object.setPrototypeOf ||
        ({
          __proto__: []
        } instanceof Array
          ? setProtoOf
          : mixinProperties);

      function setProtoOf(obj, proto) {
        obj.__proto__ = proto;
        return obj;
      }

      function mixinProperties(obj, proto) {
        for (const prop in proto) {
          if (!obj.hasOwnProperty(prop)) {
            obj[prop] = proto[prop];
          }
        }
        return obj;
      }
    })();
    Vue.prototype.tips = tips;
  }
};
